import React from "react";
import clas from "./NaviItems.module.css";
import NavigationItem from "./NavigationItem/NavigationItem";
import { Subscribe } from "unstated";
import recspContainer from "../../../Store/recspContainer";
import { Link } from "wouter";

const NavigationItems = () => {
  return (
    <ul className={clas.NavigationItems}>

      {/* Visible to everyone */}
      <Link href="/"><NavigationItem>Home</NavigationItem></Link>
      <Link href="/ex-members"><NavigationItem>Ex-Members</NavigationItem></Link>
      <Link href="/winner"><NavigationItem>Winner</NavigationItem></Link>

      {/* Login / Profile */}
      <Subscribe to={[recspContainer]}>
        {(rec) =>
          rec.state.isLoggedIn ? (
            <Link href="/profile"><NavigationItem>Profile</NavigationItem></Link>
          ) : (
            <Link href="/login"><NavigationItem>Login</NavigationItem></Link>
          )
        }
      </Subscribe>

      {/* Quiz – only when logged in */}
      <Subscribe to={[recspContainer]}>
        {(rec) =>
          rec.state.isLoggedIn ? (
            <Link href="/quiz"><NavigationItem>Quiz</NavigationItem></Link>
          ) : null
        }
      </Subscribe>

      {/* Admin – only when admin */}
      <Subscribe to={[recspContainer]}>
        {(rec) =>
          rec.checkAdmin() ? (
            <Link href="/adminpanel"><NavigationItem>Admin</NavigationItem></Link>
          ) : null
        }
      </Subscribe>

      {/* Notice Bell icon – only logged-in users */}
      <Subscribe to={[recspContainer]}>
        {(rec) =>
          rec.state.isLoggedIn ? (
            <Link href="/notice">
              <NavigationItem>
                <i className="material-icons">notification_important</i>
              </NavigationItem>
            </Link>
          ) : null
        }
      </Subscribe>

    </ul>
  );
};

export default NavigationItems;
